import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { Locked, Unlock } from '@one-thd/sui-icons';
import { rhTiers } from '../../../constants/RewardsHub';
import { BannerText } from '../RewardsHubBanner/RewardsHubBanner';
import { useIsMobile } from '../../../hooks';
export var TIER_LEVELS = {
    MEMBER: 'MEMBER',
    ELITE: 'ELITE',
    VIP: 'VIP',
};
var handleTierCapitalization = function (tierName) {
    var tierNameLowerCase = "".concat(tierName).toLowerCase();
    var tierNameCapitalized = "".concat(tierNameLowerCase).charAt(0).toUpperCase() +
        "".concat(tierNameLowerCase).slice(1);
    return "".concat(tierName) === TIER_LEVELS.VIP
        ? "".concat(tierName)
        : "".concat(tierNameCapitalized);
};
var ContainerTitle = function (_a) {
    var isLocked = _a.isLocked, tierName = _a.tierName;
    var tierNameFormatted = handleTierCapitalization("".concat(tierName));
    return (React.createElement(Typography, { variant: isLocked ? 'h4' : 'h5', color: isLocked && 'subtle' }, isLocked
        ? "Unlock ".concat(tierNameFormatted, " Tier Benefits")
        : "".concat(tierNameFormatted, " Tier Benefits Unlocked")));
};
var ContainerSubtitle = function (_a) {
    var isLocked = _a.isLocked, tierName = _a.tierName;
    return (React.createElement(Typography, { variant: "body-base" },
        isLocked && "Spend ",
        tierName &&
            rhTiers.tierSpendAmounts["".concat(tierName).toUpperCase()],
        !isLocked && " in Spend"));
};
var LockIcon = function (_a) {
    var isLocked = _a.isLocked, isMobile = _a.isMobile;
    return (React.createElement("span", { className: isLocked
            ? "sui-text-subtle ".concat(isMobile ? 'sui-pr-3' : '')
            : "sui-text-brand" }, isLocked ? React.createElement(Locked, { color: "current" }) : React.createElement(Unlock, { color: "current" })));
};
export var BenefitsHeaderContainer = function (props) {
    var tierName = props.tierName, isLocked = props.isLocked;
    var isMobile = useIsMobile().isMobile;
    var containerClassesMW = "sui-flex sui-flex-col ".concat(isLocked ? 'sui-mb-4' : '');
    var containerClassesDTW = "sm:sui-justify-between sm:sui-flex-row sm:sui-pt-1 sm:sui-pb-2 sm:sui-border-b-1 sm:sui-border-solid sm:sui-border-primary sm:sui-mb-7";
    var classesMW = "sui-flex sui-flex-row-reverse sui-justify-between sui-gap-8 sui-mb-2 sui-items-end";
    var classesDTW = "sm:sui-flex-row sm:sui-justify-start sm:sui-gap-4";
    return (React.createElement("div", { className: [containerClassesMW, containerClassesDTW].join(' ') },
        React.createElement("div", { className: [classesMW, classesDTW].join(' ') },
            React.createElement(LockIcon, { isLocked: isLocked, isMobile: isMobile }),
            React.createElement(ContainerTitle, { isLocked: isLocked, tierName: tierName })),
        React.createElement("div", { className: "sui-flex sui-items-center" }, isLocked ? (React.createElement(ContainerSubtitle, { isLocked: true, tierName: tierName })) : (!isMobile && React.createElement(BannerText, null)))));
};
export var BenefitContainer = function (props) {
    var children = props.children, tierName = props.tierName, isLocked = props.isLocked;
    var isMobile = useIsMobile().isMobile;
    return (React.createElement("div", { "data-id": "BenefitContainer__".concat(tierName) },
        isLocked && (React.createElement(BenefitsHeaderContainer, { tierName: tierName, isLocked: isLocked })),
        React.createElement("div", { className: "".concat(isLocked ? 'sui-mb-10' : '') }, children)));
};
